import {writable} from "svelte/store";
import ita from "../AppV3_i18n_ITA";
import eng from "../AppV3_i18n_EN";

let json = [ita,eng];
export const currentLanguage = writable(0);
export const Language = writable(json);